function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { createContext, useCallback, useContext, useEffect, useMemo, useReducer, useRef } from 'react';
import rootReducer from '../reducers/root';
import initialState from './initialState';
var StoreContext = /*#__PURE__*/createContext(undefined);
var mergeInitialState = function mergeInitialState(overrides) {
  return _objectSpread(_objectSpread({}, initialState), overrides);
};
export var StoreProvider = function StoreProvider(_ref) {
  var preloadedState = _ref.initialState,
    children = _ref.children;
  var _useReducer = useReducer(rootReducer, mergeInitialState(preloadedState)),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    baseDispatch = _useReducer2[1];
  var stateRef = useRef(state);
  useEffect(function () {
    stateRef.current = state;
  }, [state]);
  var getState = useCallback(function () {
    return stateRef.current;
  }, []);
  var dispatch = useCallback(function (action) {
    if (typeof action === 'function') {
      return action(dispatch, getState);
    }
    stateRef.current = rootReducer(stateRef.current, action);
    baseDispatch(action);
  }, [baseDispatch, getState]);
  var value = useMemo(function () {
    return {
      state: state,
      dispatch: dispatch,
      getState: getState
    };
  }, [state, dispatch, getState]);
  return /*#__PURE__*/React.createElement(StoreContext.Provider, {
    value: value
  }, children);
};
var useStoreContext = function useStoreContext() {
  var context = useContext(StoreContext);
  if (!context) {
    throw new Error('StoreProvider is missing in the component tree.');
  }
  return context;
};
export var useAppDispatch = function useAppDispatch() {
  return useStoreContext().dispatch;
};
export var useAppSelector = function useAppSelector(selector) {
  var _useStoreContext = useStoreContext(),
    state = _useStoreContext.state;
  return selector(state);
};
export var useAppStore = function useAppStore() {
  return useStoreContext();
};
export var createAppState = mergeInitialState;